const profile = {
    title: 'My profile',
    myAddress: 'My addresses',
    historyOrders: 'Order history',
    messages: 'Support Chat',
    bonuses: 'Your points',
    share: 'Share link',
    delivery: 'Shipping and payment',
    aboutCompany: 'About company',
    downloadApp: 'Download app',
    signOut: 'Sign out',
    btnLogoutOk: 'Yes, log out',
    deleteAccount: 'Delete account',
    modalDeleteAccount: {
        title: 'Delete account?',
        btnDelete: 'Yes',
        btnClose: 'No',
    },
    messageSignOut:
        'When you exit the profile, all products will be removed from the basket. Sign out of profile?',
    userPlaceholder: 'User name',
    emailPlaceholder: 'email',
    copy: 'Link copied',
    history: {
        repeat: 'Repeat order',
        more: 'More',
        order: 'Order №',
        cancel: 'Cancel order',
        amount: 'Amount: ',
        deliveryAmount: 'Delivery: ',
        quantity: 'Quantity: ',
    },
    agreements: {
        ads: {
            labels: {
                bannerTitle:
                    "Do you want to know about the courier's arrival time, promotions and discounts?",
                modalText:
                    'You agree to receive advertising offers via SMS, push notifications and emails. You can always opt out in your device settings.',
                checkboxLabel:
                    'I agree to receive notifications about order statuses, promotional offers and new products via push, SMS and email',
            },
            buttons: {
                bannerAgree: 'Want!',
                bannerDecline: "Don't want",
            },
        },
        privacyPolicy: {
            labels: {
                checkboxLabel: 'I agree to',
            },
            buttons: {
                checkboxDocument: 'processing of personal data',
            },
        },
    },
};

export default profile;
